// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3VZ9t","newExpiryDate":"styles_newExpiryDate__2Sidt","footer":"styles_footer__RVqtN"};